<template>
  <div class="doc-badges">
    <Badge v-if="free" primary>Free</Badge>
    <Badge>{{ readingMinutes(doc.summary_words) }} min</Badge>
    <Badge
      v-if="doc.has_audio"
      class="doc-badges__audio"
      icon="iaudio"
      aria-label="Audio available"
    />
  </div>
</template>

<script setup lang="ts">
import Badge from '@/app/components/Badge.vue'
import { readingMinutes } from '@/helpers/time'
import type { DocListItem } from '@/models/interfaces'

defineProps<{
  doc: Pick<DocListItem, 'summary_words' | 'has_audio'>
  free?: boolean
}>()
</script>

<style lang="scss" scoped>
.doc-badges {
  display: flex;
  gap: 4px;

  &__audio {
    width: 40px;
  }
}
</style>
